import { render, staticRenderFns } from "./text-decoration.vue?vue&type=template&id=5b7d4ea0&"
import script from "./text-decoration.vue?vue&type=script&lang=js&"
export * from "./text-decoration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports